/**
 * Mock data for user profiles
 */

import type { ContractorProfile } from '@hummii/shared-types';
import { VerificationStatus, UserRole } from '@hummii/shared-types';
import type { ClientProfile, ProfileReview } from '../types';

export const MOCK_PORTFOLIO: Array<ContractorProfile['portfolio'][number]> = [
  {
    id: '1',
    title: 'Kitchen Renovation',
    description: 'Complete kitchen remodel including cabinets and countertops',
    imageUrl: '/images/portfolio/kitchen-1.jpg',
    completedAt: new Date('2024-11-15'),
    order: 1,
  },
  {
    id: '2',
    title: 'Bathroom Update',
    description: 'Modern bathroom renovation with new fixtures',
    imageUrl: '/images/portfolio/bathroom-1.jpg',
    completedAt: new Date('2024-10-20'),
    order: 2,
  },
  {
    id: '3',
    title: 'Deck Installation',
    description: 'Custom cedar deck with built-in seating',
    imageUrl: '/images/portfolio/deck-1.jpg',
    completedAt: new Date('2024-09-05'),
    order: 3,
  },
  {
    id: '4',
    title: 'Home Office',
    description: 'Built-in shelving and desk setup',
    imageUrl: '/images/portfolio/office-1.jpg',
    completedAt: new Date('2024-08-10'),
    order: 4,
  },
];

export const MOCK_CONTRACTOR_PROFILE: ContractorProfile = {
  id: 'contractor-1',
  userId: 'user-1',
  bio: 'Professional contractor with over 10 years of experience in home renovations and repairs. Specializing in kitchen and bathroom remodels, I take pride in delivering quality work on time and within budget.',
  experience: 10,
  hourlyRate: 75,
  businessName: 'Smith Renovations',
  latitude: 43.6532,
  longitude: -79.3832,
  address: '123 Main St',
  city: 'Toronto',
  province: 'ON',
  postalCode: 'M5V 1A1',
  serviceRadius: 50,
  verificationStatus: VerificationStatus.VERIFIED,
  verificationDate: new Date('2020-04-01'),
  totalOrders: 156,
  completedOrders: 142,
  isAvailable: true,
  createdAt: new Date('2020-03-15'),
  updatedAt: new Date('2024-12-01'),
  user: {
    id: 'user-1',
    name: 'John Smith',
    avatarUrl: null,
    isVerified: true,
    roles: [UserRole.CONTRACTOR],
  },
  categories: [
    { id: 'cc-1', category: { id: '1', nameEn: 'Home Renovation', nameFr: 'Rénovation domiciliaire', slug: 'home-renovation' } },
    { id: 'cc-2', category: { id: '2', nameEn: 'Plumbing', nameFr: 'Plomberie', slug: 'plumbing' } },
    { id: 'cc-3', category: { id: '3', nameEn: 'Carpentry', nameFr: 'Menuiserie', slug: 'carpentry' } },
  ],
  portfolio: MOCK_PORTFOLIO,
  ratingDistribution: {
    fiveStars: 67, // 75% of 89 reviews
    fourStars: 15, // 17%
    threeStars: 5,  // 6%
    twoStars: 1,    // 1%
    oneStar: 1,     // 1%
  },
};

export const MOCK_CLIENT_PROFILE: ClientProfile = {
  id: 'client-1',
  name: 'Sarah Johnson',
  avatarUrl: null,
  isVerified: true,
  city: 'Montreal',
  province: 'QC',
  memberSince: new Date('2021-06-20'),
  totalOrders: 23,
  activeOrders: 2,
};

export const MOCK_PROFILE_REVIEWS: ProfileReview[] = [
  {
    id: 'review-1',
    rating: 5,
    comment: 'Excellent work! John completed our kitchen renovation ahead of schedule and the quality exceeded our expectations. Highly recommend!',
    criteriaRatings: { quality: 5, professionalism: 5, communication: 5, value: 5 },
    isEdited: false,
    createdAt: new Date('2024-11-20'),
    reviewer: {
      id: 'reviewer-1',
      name: 'Michael Chen',
      avatarUrl: null,
      isVerified: true,
    },
    response: null,
  },
  {
    id: 'review-2',
    rating: 5,
    comment: 'Very professional and reliable. Great communication throughout the project.',
    criteriaRatings: { quality: 5, professionalism: 5, communication: 5, value: 4 },
    isEdited: false,
    createdAt: new Date('2024-10-15'),
    reviewer: {
      id: 'reviewer-2',
      name: 'Emily Davis',
      avatarUrl: null,
      isVerified: true,
    },
    response: null,
  },
  {
    id: 'review-3',
    rating: 4,
    comment: 'Good quality work. Minor delay but overall satisfied with the results.',
    criteriaRatings: { quality: 4, professionalism: 4, communication: 4, value: 4 },
    isEdited: false,
    createdAt: new Date('2024-09-28'),
    reviewer: {
      id: 'reviewer-3',
      name: 'David Wilson',
      avatarUrl: null,
      isVerified: false,
    },
    response: null,
  },
  {
    id: 'review-4',
    rating: 5,
    comment: 'Outstanding craftsmanship and attention to detail. Would hire again without hesitation.',
    criteriaRatings: { quality: 5, professionalism: 5, communication: 5, value: 5 },
    isEdited: false,
    createdAt: new Date('2024-08-12'),
    reviewer: {
      id: 'reviewer-4',
      name: 'Lisa Anderson',
      avatarUrl: null,
      isVerified: true,
    },
    response: null,
  },
];
